import { render, staticRenderFns } from "./YamlEditor.vue?vue&type=template&id=50851afa&scoped=true&"
import script from "./YamlEditor.vue?vue&type=script&lang=js&"
export * from "./YamlEditor.vue?vue&type=script&lang=js&"
import style0 from "./YamlEditor.vue?vue&type=style&index=0&id=50851afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50851afa",
  null
  
)

export default component.exports